module.exports = __webpack_public_path__ + "img/nix18.d1b7711.png";